module.exports = __webpack_public_path__ + "img/m-banner.f5fc8a6c.png";